<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：门店-订单核销记录
        -->
    <div class="user">

      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="所属门店">
            <el-select v-model="formInline.store_id" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item,index) in storeList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单人姓名">
            <el-input v-model="formInline.search" placeholder="请输入下单人姓名"></el-input>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input v-model="formInline.order" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="common-level-rail" style="margin-right:20px;">
            <el-button size="small" @click="batchExport">批量导出</el-button>
          </div>
      </div>
    
  
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="nickname" label="下单用户"></el-table-column>
            <el-table-column prop="pay_type" label="支付方式">
              <template #default="scope">
                {{ getPayTypeText(scope.row.pay_type) }}
              </template>
            </el-table-column>
                 <el-table-column prop="or_price" label="原支付金额"></el-table-column>
             <el-table-column prop="dk_price" label="抵扣金额"></el-table-column>
              <el-table-column prop="pay_price" label="实际支付金额"></el-table-column>
            <el-table-column prop="pay_status" label="支付状态">
              <template #default="scope">
                {{ getPayStatusText(scope.row.pay_status) }}
              </template>
            </el-table-column>
            <el-table-column prop="transaction_id" label="支付交易号"></el-table-column>
            <el-table-column prop="pay_time" label="支付时间"></el-table-column>
            <el-table-column 
            prop="is_refund" 
            label="退款"
            :formatter="(row) => ({
               0: '未申请退款',
               1: '申请退款',
               2: '申请退款审核通过',
               3: '申请退款审核不通过'
               }[row.is_refund] || row.is_refund)">
               </el-table-column>
               <el-table-column prop="canel_val" label="取消退款原因"></el-table-column>
            <el-table-column
             prop="order_status" 
             label="核销状态"
             :formatter="(row) => ({
               10: '未核销',
               20: '已核销',
               }[row.order_status] || row.order_status)"
             ></el-table-column>
             <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>




            <div v-if="dialogVisible" class="modal-mask">
    <div class="modal-container">
      <h3>拒绝退款</h3>
      <textarea v-model="rejectForm.reject_val"></textarea>
      <div class="modal-actions">
        <button @click="dialogVisible = false">取消</button>
        <button @click="submitReject">确认</button>
      </div>
    </div>
  </div>
          </el-table>

        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
         layout="total,sizes, prev, pager, next, jumper "
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
    import StoreApi from '@/api/store.js';
    import qs from 'qs';
    import { ref } from 'vue'
    export default {
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*所属门店数据*/
          storeList: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*横向表单数据模型*/
          formInline: {
            store_id: '',
            search: '',
            order:"",
            time:""
          },
          /*是否打开添加弹窗*/
          open_add: false,
          /*是否打开编辑弹窗*/
          open_edit: false,
          /*当前编辑的对象*/
          userModel: {},
            /*选中的*/
          multipleSelection: [],
          dialogVisible: false,
          rejectForm: {
            pay_order_id: '',
            order_no: '',
            reject_val: ''
          }
        };
      },
      created() {
  
        /*获取列表*/
        this.getTableList();
  
      },
      methods: {
  
        /*选择第几页*/
        handleCurrentChange(val) {
          let self = this;
          self.curPage = val;
          self.loading = true;
          self.getTableList();
        },
        openRejectDialog(row){
          this.rejectForm = {
            pay_order_id: row.pay_order_id,
            order_no: row.order_no,
            reject_val: ''
          }
          this.dialogVisible = true
          console.log(this.dialogVisible);
        },

        // 提交拒绝退款
  submitReject() {
    if (!this.rejectForm.reject_val) {
      this.$message.warning('请填写拒绝原因')
      return
    }
    
    this.$confirm('确定要拒绝该退款申请吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.loading = true
      
      // 调用API
      // rejectRefund({
      //   order_id: this.rejectForm.pay_order_id,
      //   reject_val: this.rejectForm.reject_val
      // }).then(response => {
      //   this.$message.success('拒绝退款成功')
      //   this.rejectDialogVisible = false
      //   this.getTableData() // 刷新表格数据
      // }).catch(error => {
      //   this.$message.error(error.message || '操作失败')
      // }).finally(() => {
      //   this.loading = false
      // })
    })
  },

        handleRefund(row) {
          console.log(row);
          
          this.$confirm('确定要退款吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
      // 调用退款API
      StoreApi.approveRefund({
        order_id:row.pay_order_id
      }).then(response => {
        this.$message.success(response.msg);
        // 刷新表格数据
        this.getTableList();
      }).catch(error => {
        this.$message.error(error.message || '退款失败');
      });
    }).catch(() => {
      this.$message.info('已取消退款');
    });
  },

        getPayTypeText(type) {
          const payTypeMap = {
            10: '余额',
            20: '微信',
            30: '支付宝',
            40: '花呗',
            50: 'app微信',
            60: 'app支付宝'
          };
          return payTypeMap[type] || type; 
        },

        getPayStatusText(status) {
          const statusMap = {
            10: '待支付',
            20: '已支付',
            30: '退还已返还',
          };
          return statusMap[status] || status;
        },
     /*选择数据*/
     handleSelectionChange(e) {
        this.multipleSelection = e;
      },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = self.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
           self.loading = true;
           StoreApi.orderList(Params, true)
           .then(data => {
            self.loading = false;
            self.storeList = data.data.store_list.data
           })
          StoreApi.payOrderlist(Params,true)
            .then(data => {
              self.loading = false;
              console.log("data.data.shop_list.data",data.data)
              self.tableData = data.data.list;
              self.totalDataNumber = data.data.total || 0;
            })
            .catch(error => {
              self.loading = false;
            });
        },
        batchExport(){//批量导出
          // 勾选需要导出的数据
          let ids = [];
        let params = this.multipleSelection;
        console.log("params",params)
        params.forEach((param)=>{
          ids.push(param.store_id);
        })
        ids = ids.join(',');
        // 筛选条件
        // 商品状态
        var parmasa =  this.searchForm?this.searchForm:{};
        console.log("parmasa",parmasa)
        parmasa["list_rows"] = this.pageSize
        parmasa["page"] = this.curPage
        if(ids.length > 0){
          // console.log(this.searchForm)
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/index.php/shop/product.product/exportHexiao?' + 
          qs.stringify(parmasa)+'&ids='+ids;
          
        }else{
          this.$message({
              message: '请选择要导出的数据',
              type: 'error'
            });
        }
     
  
      },
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
  
      }
    };
  </script>
  
  <style>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/store/order/pay.vue